module.exports = __webpack_public_path__ + "img/Picture4.d5dd5c85.jpg";